import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classnames from 'classnames';
import Image from 'next/image';
import React from 'react';
import styles from './modal-information.module.scss';
import { Modal } from '../modal/modal';
import { Button } from '../../button';
import { Icon } from '../../icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ModalInformation = function ModalInformation(_ref) {
  var _classnames;

  var _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      title = _ref.title,
      description = _ref.description,
      disclaimer = _ref.disclaimer,
      hasTermsOnDescription = _ref.hasTermsOnDescription,
      image = _ref.image,
      imageHighlight = _ref.imageHighlight,
      showBackground = _ref.showBackground,
      badge = _ref.badge,
      danger = _ref.danger,
      confirmIcon = _ref.confirmIcon,
      confirmLabel = _ref.confirmLabel,
      onConfirm = _ref.onConfirm,
      onDismiss = _ref.onDismiss,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
      _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve;
  return /*#__PURE__*/_jsx(Modal, {
    label: "information",
    targetId: "moises-app",
    isOpen: show,
    showCloseButton: showCloseButton,
    onClose: onDismiss,
    modalClassName: styles.modal,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    children: /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.content, (_classnames = {}, _defineProperty(_classnames, styles.hasImageHighlight, !!imageHighlight), _defineProperty(_classnames, styles.background, showBackground), _defineProperty(_classnames, styles.extraPadding, !showCloseButton), _classnames)),
      children: [badge && /*#__PURE__*/_jsx("div", {
        className: styles.badge,
        children: badge
      }), image && /*#__PURE__*/_jsx("div", {
        className: styles.image,
        children: /*#__PURE__*/_jsx(Image, {
          alt: "",
          src: "/assets/images/".concat(image, ".svg"),
          width: showBackground ? '80' : '100',
          height: showBackground ? '110' : '100',
          style: {
            top: showBackground ? '' : '-10px'
          }
        })
      }), imageHighlight && /*#__PURE__*/_jsx("div", {
        className: styles.imageHighlight,
        children: /*#__PURE__*/_jsx(Image, {
          alt: "",
          fill: true,
          src: "/assets/images/".concat(imageHighlight)
        })
      }), /*#__PURE__*/_jsx("p", {
        className: styles.title,
        children: title
      }), description ? /*#__PURE__*/_jsx("p", {
        className: styles.description,
        children: hasTermsOnDescription ? /*#__PURE__*/_jsx("span", {
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML: {
            __html: description.replace(/\*([^*]+)\*/g, "<a class=\"".concat(styles.link, "\" target=\"_BLANK\" href=\"https://help.moises.ai/hc/en-us/articles/5968943445404\">$1</a>"))
          }
        }) : description
      }) : null, disclaimer ? /*#__PURE__*/_jsx("p", {
        className: styles.disclaimer,
        children: disclaimer
      }) : null, /*#__PURE__*/_jsx("div", {
        className: styles.actions,
        children: /*#__PURE__*/_jsx(Button, {
          small: true,
          radius: 1,
          danger: danger,
          onClick: onConfirm,
          className: styles.button,
          id: "modal_button_confirm",
          title: confirmLabel,
          icon: confirmIcon ? /*#__PURE__*/_jsx(Icon, {
            name: confirmIcon,
            width: 22,
            height: 22
          }) : undefined
        })
      })]
    })
  });
};